import { axiosInstance } from "../../../axios/axiosInstance";

const API_GIFT_CARD_URL = "admin/gift_card";
const API_CREATE_GIFT_CARD_MODULE_URL = API_GIFT_CARD_URL + "/create";
const API_UPDATE_GIFT_CARD_MODULE_URL = API_GIFT_CARD_URL + "/update";
const API_GET_GIFT_CARD_MODULE_URL = API_GIFT_CARD_URL + "/list";
const API_GET_GIFT_CARD_MODULE_BY_ID_URL = API_GIFT_CARD_URL + "/view";
const API_DELETE_GIFT_CARD_MODULE_BY_ID_URL =
  API_GIFT_CARD_URL + "/update-status";

export const getGiftCards = (dataToBeSent) => {
  return axiosInstance.post(
    `${API_GET_GIFT_CARD_MODULE_URL}?page=${dataToBeSent?.page || ""}&limit=${
      dataToBeSent?.limit || ""
    }&search=${dataToBeSent?.search || ""}`
  );
};
export const createGiftCard = (dataToBeSent) => {
  return axiosInstance.post(API_CREATE_GIFT_CARD_MODULE_URL, dataToBeSent);
};
export const updateGiftCard = (dataToBeSent) => {
  return axiosInstance.post(
    API_UPDATE_GIFT_CARD_MODULE_URL + "/" + dataToBeSent?._id,
    dataToBeSent
  );
};
export const getGiftCardById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_GIFT_CARD_MODULE_BY_ID_URL + "/" + dataToBeSent?.selectedGiftCardId,
    dataToBeSent
  );
};
export const deleteGiftCardById = (dataToBeSent) => {
  return axiosInstance.patch(
    API_DELETE_GIFT_CARD_MODULE_BY_ID_URL +
      "/" +
      dataToBeSent?.selectedGiftCardId,
    {
      is_active: false,
    }
  );
};
